import { render, staticRenderFns } from "./BranchSenderPolicyTab.vue?vue&type=template&id=6fd65e96&scoped=true"
import script from "./BranchSenderPolicyTab.vue?vue&type=script&lang=js"
export * from "./BranchSenderPolicyTab.vue?vue&type=script&lang=js"
import style0 from "./BranchSenderPolicyTab.vue?vue&type=style&index=0&id=6fd65e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd65e96",
  null
  
)

export default component.exports